// import React, { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";

// const Accordian = ({
//   title,
//   children,
//   icon = "keyboard_arrow_down",
//   iconType = "outlined", // contained, outlined
//   variant = "contained", // contained, outlined, text
//   //size = "md", //xs, xs-sm, sm, md, lg, xl
//   color = "primary", // primary, warning, success, danger, info, black, white
//   defaultOpen = false,
//   iconColor = "primary",
//   rounded = "sm",
// }) => {
//   const [isOpen, setIsOpen] = useState(defaultOpen);
//   console.log("isOpen", isOpen);
//   console.log("color", color);

//   const IconColor = {
//     primary: {
//       contained: isOpen
//         ? "text-white border border-white "
//         : "text-white border border-white",
//       outlined: isOpen
//         ? "text-white border border-white"
//         : "text-white border border-white",
//       text: isOpen ? "text-white" : "text-primary",
//     },
//     warning: {
//       contained: isOpen
//         ? "text-warning border border-warning"
//         : "text-warning border border-warning",
//       outlined: isOpen
//         ? "text-warning border border-warning"
//         : "text-warning border border-warning",
//       text: isOpen ? "text-warning" : "text-primary",
//     },
//     danger: {
//       contained: isOpen
//         ? "text-white border border-white"
//         : "text-white border border-white",
//       outlined: isOpen
//         ? "text-white border border-white"
//         : "text-white border border-white",
//       text: isOpen ? "text-danger" : "text-primary",
//     },
//     info: {
//       contained: isOpen
//         ? "text-info border border-info"
//         : "text-info border border-info",
//       outlined: isOpen
//         ? "text-info border border-info"
//         : "text-info border border-info",
//       text: isOpen ? "text-info" : "text-primary",
//     },
//     black: {
//       contained: isOpen
//         ? " text-black border border-black"
//         : " text-black border border-black",
//       outlined: isOpen
//         ? "text-black border border-black"
//         : "text-black border border-black",
//       text: isOpen ? "text-black" : "text-primary",
//     },
//     white: {
//       contained: isOpen
//         ? "text-black border border-white"
//         : "text-black border border-white",
//       outlined: isOpen
//         ? "text-black border border-white"
//         : "text-black border border-white",
//       text: isOpen ? "text-white" : "text-primary",
//     },
//   };

//   const colors = {
//     primary: {
//       contained: isOpen
//         ? "bg-primary-700 text-white border border-primary-700"
//         : "bg-primary text-white hover:bg-primary-600 border border-primary",
//       outlined: isOpen
//         ? "bg-primary-50 border border-primary text-primary"
//         : "border-[1px] border-primary text-primary hover:bg-primary-50",
//       text: isOpen
//         ? "bg-primary-50 text-primary"
//         : "text-primary hover:bg-primary-50",
//     },
//     warning: {
//       contained: isOpen
//         ? "bg-warning-700 text-white border border-warning-700"
//         : "bg-warning text-white hover:bg-warning-600 border border-warning",
//       outlined: isOpen
//         ? "bg-warning-50 border border-warning text-warning"
//         : "border border-warning text-warning hover:bg-warning-50",
//       text: isOpen
//         ? "bg-warning-50 text-warning"
//         : "text-warning hover:bg-warning-50",
//     },
//     success: {
//       contained: isOpen
//         ? "bg-success-700 text-white border border-success-700"
//         : "bg-success text-white hover:bg-success-600 border border-success",
//       outlined: isOpen
//         ? "bg-success-50 border border-success text-success"
//         : "border border-success text-success hover:bg-success-50",
//       text: isOpen
//         ? "bg-success-50 text-success"
//         : "text-success hover:bg-success-50",
//     },
//     danger: {
//       contained: isOpen
//         ? "bg-danger-700 text-white border border-danger-700"
//         : "bg-danger text-white hover:bg-danger-600 border border-danger",
//       outlined: isOpen
//         ? "bg-danger-50 border border-danger text-danger"
//         : "border border-danger text-danger hover:bg-danger-50",
//       text: isOpen
//         ? "bg-danger-50 text-danger"
//         : "text-danger hover:bg-danger-50",
//     },
//     info: {
//       contained: isOpen
//         ? "bg-info-700 text-white border border-info-700"
//         : "bg-info text-white hover:bg-info-600 border border-info",
//       outlined: isOpen
//         ? "bg-info-50 border border-info text-info"
//         : "border border-info text-info hover:bg-info-50",
//       text: isOpen ? "bg-info-50 text-info" : "text-info hover:bg-info-50",
//     },
//     black: {
//       contained: isOpen
//         ? "bg-gray-700 text-white border border-gray-700"
//         : "bg-gray-600 border-gray-600 text-white hover:bg-gray-700 border hover:border-gray-700",
//       outlined: isOpen
//         ? "bg-gray-200 bg-opacity-50 border border-black text-black"
//         : "border border-black text-black hover:bg-gray-200",
//       text: isOpen
//         ? "bg-gray-100 text-black bg-opacity-50"
//         : "text-black hover:bg-gray-100",
//     },
//     white: {
//       contained: isOpen
//         ? "bg-neutrals-50 text-black border-[1px] "
//         : "bg-neutrals-50 border-[1px] border-neutrals-200 text-black ",
//       outlined: isOpen
//         ? "bg-gray-500 bg-opacity-50 border border-white text-white"
//         : "border border-white text-white hover:bg-gray-500 hover:bg-opacity-50 hover:border-white",
//       text: isOpen
//         ? "bg-gray-500 bg-opacity-50 text-white"
//         : "text-white hover:bg-gray-500 hover:bg-opacity-50",
//     },
//   };

//   console.log("fdfdsfds", IconColor[iconColor]?.[variant]);
//   return (
//     // <div className={`inline-block w-full border${colors[color][variant]} `}>
//     <div
//       className={`inline-block w-full border${colors[color][variant]} rounded-${rounded}`}
//     >
//       <motion.div
//         className={`flex gap-2 justify-between items-center cursor-pointer rounded-tr-${rounded} rounded-tl-${rounded} px-2 py-2.5 ${colors[color][variant]}`}
//         onClick={() => setIsOpen(!isOpen)}
//       >
//         <div className="text-sm">{title}</div>
//         <motion.span
//           className={`material-symbols-rounded flex items-center justify-center  leading-none w-4 h-4 text-base rounded-full ${
//             iconType === "outlined"
//               ? ` ${IconColor[iconColor]?.[variant] || ""}`
//               : "bg-gray-950"
//           }`}
//           animate={{ rotate: isOpen ? 180 : 0 }}
//           transition={{ duration: 0.3 }}
//         >
//           {icon}
//         </motion.span>
//       </motion.div>

//       <AnimatePresence initial={false}>
//         {isOpen && (
//           <motion.div
//             initial={{ height: 0, opacity: 0 }}
//             animate={{ height: "auto", opacity: 1 }}
//             exit={{ height: 0, opacity: 0 }}
//             transition={{ duration: 0.3, ease: "easeInOut" }}
//             style={{ overflow: "hidden" }}
//             className={`bg-white text-black rounded-${rounded} `}
//           >
//             <div className="px-2 py-2.5 text-sm">{children}</div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

// export default Accordian;

import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const Accordian = ({
  title,
  children,
  icon = "keyboard_arrow_down",
  iconType = "outlined", // contained, outlined
  variant = "contained", // contained, outlined, text
  color = "primary", // primary, warning, success, danger, info, black, white
  defaultOpen = false,
  iconColor = "primary",
  rounded = "",
  handleChangeOption,
  bodyPadding="px-2.5 py-2"
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const IconColor = {
    primary: {
      contained: isOpen
        ? "text-white border border-white"
        : "text-white border border-white",
      outlined: isOpen
        ? "text-white border border-white"
        : "text-white border border-white",
      text: isOpen ? "text-white" : "text-primary",
    },
    warning: {
      contained: isOpen
        ? "text-warning border border-warning"
        : "text-warning border border-warning",
      outlined: isOpen
        ? "text-warning border border-warning"
        : "text-warning border border-warning",
      text: isOpen ? "text-warning" : "text-primary",
    },
    danger: {
      contained: isOpen
        ? "text-white border border-white"
        : "text-white border border-white",
      outlined: isOpen
        ? "text-white border border-white"
        : "text-white border border-white",
      text: isOpen ? "text-danger" : "text-primary",
    },
    info: {
      contained: isOpen
        ? "text-info border border-info"
        : "text-info border border-info",
      outlined: isOpen
        ? "text-info border border-info"
        : "text-info border border-info",
      text: isOpen ? "text-info" : "text-primary",
    },
    black: {
      contained: isOpen
        ? "text-black border border-black"
        : "text-black border border-black",
      outlined: isOpen
        ? "text-black border border-black"
        : "text-black border border-black",
      text: isOpen ? "text-black" : "text-primary",
    },
    white: {
      contained: isOpen
        ? "text-black border border-white"
        : "text-black border border-white",
      outlined: isOpen
        ? "text-black border border-white"
        : "text-black border border-white",
      text: isOpen ? "text-white" : "text-primary",
    },
  };

  const colors = {
    primary: {
      contained: isOpen
        ? "bg-primary text-white border border-primary"
        : "bg-primary text-white hover:bg-primary-500 border border-primary",
      outlined: isOpen
        ? "bg-primary-50 border border-primary text-primary"
        : "border-[1px] border-primary text-primary hover:bg-primary-50",
      text: isOpen
        ? "bg-primary-50 text-primary"
        : "text-primary hover:bg-primary-50",
    },
    warning: {
      contained: isOpen
        ? "bg-warning-700 text-white border border-warning-700"
        : "bg-warning text-white hover:bg-warning-600 border border-warning",
      outlined: isOpen
        ? "bg-warning-50 border border-warning text-warning"
        : "border border-warning text-warning hover:bg-warning-50",
      text: isOpen
        ? "bg-warning-50 text-warning"
        : "text-warning hover:bg-warning-50",
    },
    success: {
      contained: isOpen
        ? "bg-success-700 text-white border border-success-700"
        : "bg-success text-white hover:bg-success-600 border border-success",
      outlined: isOpen
        ? "bg-success-50 border border-success text-success"
        : "border border-success text-success hover:bg-success-50",
      text: isOpen
        ? "bg-success-50 text-success"
        : "text-success hover:bg-success-50",
    },
    danger: {
      contained: isOpen
        ? "bg-danger-700 text-white border border-danger-700"
        : "bg-danger text-white hover:bg-danger-600 border border-danger",
      outlined: isOpen
        ? "bg-danger-50 border border-danger text-danger"
        : "border border-danger text-danger hover:bg-danger-50",
      text: isOpen
        ? "bg-danger-50 text-danger"
        : "text-danger hover:bg-danger-50",
    },
    info: {
      contained: isOpen
        ? "bg-info-700 text-white border border-info-700"
        : "bg-info text-white hover:bg-info-600 border border-info",
      outlined: isOpen
        ? "bg-info-50 border border-info text-info"
        : "border border-info text-info hover:bg-info-50",
      text: isOpen ? "bg-info-50 text-info" : "text-info hover:bg-info-50",
    },
    black: {
      contained: isOpen
        ? "bg-gray-700 text-white border border-gray-700"
        : "bg-gray-600 border-gray-600 text-white hover:bg-gray-700 border hover:border-gray-700",
      outlined: isOpen
        ? "bg-gray-200 bg-opacity-50 border border-black text-black"
        : "border border-black text-black hover:bg-gray-200",
      text: isOpen
        ? "bg-gray-100 text-black bg-opacity-50"
        : "text-black hover:bg-gray-100",
    },
    white: {
      contained: isOpen
        ? "bg-neutrals-50 text-black border border-neutrals-300"
        : "bg-neutrals-50 text-black  border border-neutrals-300",
      outlined: isOpen
        ? "bg-neutrals-50 bg-opacity-50 border border-neutrals-200 text-white"
        : " text-black hover:bg-gray-500 hover:bg-opacity-50 hover:border-white",
      text: isOpen
        ? "bg-gray-500 bg-opacity-50 text-white"
        : "text-white  hover:bg-gray-500 hover:bg-opacity-50",
    },
  };

  // Get the appropriate border radius classes
  const getBorderRadius = () => {
    const radius = {
      none: "",
      sm: "rounded-sm",
      md: "rounded-md",
      lg: "rounded-lg",
      xl: "rounded-xl",
      "2xl": "rounded-2xl",
      "3xl": "rounded-3xl",
      full: "rounded-full",
    };

    return radius[rounded] || "rounded-sm";
  };

  // Get header border radius (all corners when closed, only top corners when open)
  const getHeaderBorderRadius = () => {
    const radius = {
      none: "",
      sm: isOpen ? "rounded-t-sm" : "rounded-sm",
      md: isOpen ? "rounded-t-md" : "rounded-md",
      lg: isOpen ? "rounded-t-lg" : "rounded-lg",
      xl: isOpen ? "rounded-t-xl" : "rounded-xl",
      "2xl": isOpen ? "rounded-t-2xl" : "rounded-2xl",
      "3xl": isOpen ? "rounded-t-3xl" : "rounded-3xl",
      full: isOpen ? "rounded-t-full" : "rounded-full",
    };

    return radius[rounded] || "rounded-sm";
  };

  // Get content border radius (only bottom corners)
  const getContentBorderRadius = () => {
    const radius = {
      none: "",
      sm: "rounded-b-sm",
      md: "rounded-b-md",
      lg: "rounded-b-lg",
      xl: "rounded-b-xl",
      "2xl": "rounded-b-2xl",
      "3xl": "rounded-b-3xl",
      full: "rounded-b-full",
    };

    return radius[rounded] || "rounded-b-sm";
  };

  // const handleChange = () => {
  //   if (setOpenClick) {
  //     setOpenClick(!isOpen);
  //   }
  //   setIsOpen(!isOpen);
  // };

  const handleChange = () => {
    if (handleChangeOption) {
      handleChangeOption();
    }
    setIsOpen(!isOpen);
  };

  return (
    <div
      className={`inline-block w-full overflow-auto ${getBorderRadius()} ${
        isOpen ? "w-fll " : "w-fit"
      }`}
    >
      <motion.div
        className={`flex gap-2 justify-between items-center cursor-pointer ${getHeaderBorderRadius()} px-2.5 py-2 ${
          colors[color][variant]
        }`}
        // onClick={() => setIsOpen(!isOpen)}
        onClick={() => handleChange()}
      >
        <div>{title}</div>
        <motion.span
          className={`material-symbols-rounded flex items-center justify-center leading-none w-4 h-4 text-base rounded-full ${
            iconType === "outlined"
              ? `${IconColor[iconColor]?.[variant] || ""}`
              : "bg-gray-950"
          }`}
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.3 }}
        >
          {icon}
        </motion.span>
      </motion.div>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            style={{ overflow: "hidden" }}
            // className={`bg-white text-black ${getContentBorderRadius()} border-x border-b border-${color}`}
            className={`bg-white overflow-hidden text-black ${getContentBorderRadius()} border-x border-b ${
              color === "white" ? "border-neutrals-300" : `border-${color}`
            }`}
          >
            <div className={`${bodyPadding} text-sm`}>{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Accordian;
